export default __webpack_public_path__ + "static/media/pin_red.462b4568.svg";